import React, { useState } from "react";
import {
  ArrowRight,
  Check,
  ChevronDown,
  CircleCheck,
  DoorClosedIcon,
  Plus,
  X,
} from "lucide-react";
import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import AcceptTableScreen from "./Components/AcceptTable";
import TaxTable from "./Components/TaxTable";
import Modal from "@mui/material/Modal";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import {
  DatePicker,
  DateTimePicker,
  StaticDatePicker,
} from "@mui/x-date-pickers";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "47.719vw",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
};

const top100Films = [
  { label: "SGST", year: 1994 },
  { label: "CGST", year: 1972 },
  { label: "Rounded Off (+)", year: 1974 },
  { label: "Rounded off (-)", year: 2008 },
  { label: "Frieght & Forwarding Charges", year: 1957 },
  { label: "Labour Charge", year: 1957 },
];

const AcceptOrderScreen = () => {
  const [gst, setgst] = useState(false);

  const handlegst = () => {
    setgst(!gst);
  };

  const [gstval, setgstval] = useState("Input");

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [add, setadd] = useState(true);

  const [value, setValue] = React.useState(dayjs("2024-06-15"));

  return (
    <div className=" h-[88.000593vh] overflow-y-scroll customScrollBar">
      <div className="flex flex-row ml-[2.083333vw] mt-[3.5185vh] mr-[2.638888vw] gap-x-10">
        <span className="flex flex-row items-center justify-center">
          <span className="ml-9 mr-10 text-[18px] font-outfit font-medium text-[#848484]">
            Date:
          </span>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["StaticDatePicker"]}>
              <DatePicker
                label="Date"
                name="startDate"
                value={value}
                onChange={newValue => setValue(newValue)}
              />
            </DemoContainer>
          </LocalizationProvider>
        </span>
        <span className="flex flex-row items-center justify-center">
          <span className="mx-5 w-[7vw] text-[18px] font-outfit font-medium text-[#848484]">
            VCH no :
          </span>
          <TextField
            id="outlined-basic"
            label="RS/0001/22/23"
            variant="outlined"
            className="w-[100%]"
            size="small"
          />
        </span>
      </div>
      <div className="flex flex-row items-center justify-start ml-[3.483333vw] mt-[3.5185vh] mr-[2.638888vw] gap-x-5">
        <span className="w-[5.8vw] text-[18px] font-outfit font-normal text-[#848484]">
          GST Type :
        </span>

        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={top100Films}
          sx={{ width: 280 }}
          size="small"
          style={{ fontSize: 1 }}
          renderInput={params => <TextField {...params} label="Input" />}
        />
      </div>

      <div className="bg-white  rounded-xl ml-[2.083333vw] mt-[3.5185vh] mr-[2.638888vw]">
        <p className="flex flex-col pb-2 border-b-2 border-zinc-300 rounded-md w-[100%] mx-auto">
          <span className="w-[80%] flex items-senter ml-[3.3%] mt-[1.7%] text-[2.81vh] font-medium font-outfit h-[5.5vh]">
            Firm details
          </span>{" "}
        </p>
        <div className="pb-10 w-[100%]">
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex flex-row gap-x-[10.27%] mt-[3.6886%] ml-[3.7%]  font-outfit font-normal ">
                <p>Firm Name</p> <p>Madhur Creation</p>
              </div>
              <div className="flex flex-row gap-x-[3.97%] mt-[1.6886%] ml-[3.7%]  font-outfit font-normal ">
                <p>Customer Name</p> <p>Chaitanya Goyal</p>
              </div>
            </div>
            <div className="flex flex-col">
              <div className="flex flex-row gap-x-[7.97%] mt-[3.6886%]  ml-[3.7%] font-outfit font-normal ">
                <p>Phone Number</p> <p>+91 7898747967</p>
              </div>
              <div className="flex flex-row gap-x-[18.97%] mt-[1.6886%] ml-[3.7%] font-outfit font-normal ">
                <p>GSTIN</p> <p>78115264569</p>
              </div>
            </div>
          </div>
          <div className="flex flex-row gap-x-[3.57%] mt-[0.7886%] ml-[1.9%] font-outfit font-normal ">
            <p>Shop Address</p> <p>31, Dwarka dham colony mangliya </p>
          </div>
        </div>
      </div>

      <AcceptTableScreen />

      <div className="flex flex-row ml-[2.083333vw] mt-[3.5185vh] mr-[2.638888vw] border border-zinc-100 px-2 rounded-xl">
        <div className="flex w-[40%]">
          <fieldset className="flex items-start justify-start flex-col w-[26.878333vw] h-[21vw] pb-[6.186111vh] mx-[1.52222vw]  rounded-lg mt-[1.059259259vh] box-border border-dotted border-2 border-zinc-400">
            <legend className="ml-[1.851851vh] text-[13px] font-outfit font-medium text-[#49454F]">
              Tax Summary
            </legend>

            <p className="font-poppins text-[2vh] font-medium mt-[1.42%] text-[#79747E] mx-3">
              Tax Rate
            </p>
          </fieldset>
        </div>
        <div className=" w-[60%] flex flex-col items-start justify-start">
          <TaxTable add={add} setadd={setadd} />

          <div className="w-[100%]  box-border flex items-end mt-2 justify-end ">
            {" "}
            <button
              className={`border-[2px] border-[#5652B0] text-[#5652B0] text-[17px] font-medium font-outfit flex flex-row gap-x-2 py-1 px-2 rounded-lg ${
                add ? "hidden" : ""
              } `}
              onClick={() => setadd(!add)}>
              {" "}
              <Plus color="#5652B0" /> Add
            </button>
          </div>
          <div
            className={`flex flex-row items-start justify-start border border-[#BEBEBE] rounded-sm  mt-5 ${
              add === true ? "w-[96%]" : "w-[100%]"
            } `}>
            <p className="w-[30%] font-outfit font-medium border-r-2 border-black p-2">
              Grand Total
            </p>{" "}
            <p className="p-2 flex items-end justify-end w-[61%] font-outfit">
              <span className="font-outfit font-medium"></span>34,099
            </p>
          </div>
        </div>
      </div>

      <p className="flex flex-col ml-[2.083333vw] mt-[3.5185vh] mr-[2.638888vw]">
        <span className="w-[80%] flex items-senter ml-[3.3%] mt-[1.7%] text-[2.81vh] font-medium font-outfit h-[5.5vh]">
          Note
        </span>{" "}
      </p>

      <div className="bg-white  rounded-xl ml-[2.083333vw] mr-[2.638888vw]">
        <p className="flex flex-col pb-2 border-b-2 border-zinc-300 rounded-md w-[100%] mx-auto">
          <span className="w-[80%] flex items-senter ml-[3.3%] mt-[1.7%] text-[2.21vh] font-medium font-outfit h-[5.5vh]">
            Voucher Used
          </span>{" "}
        </p>
        <div className="pb-10 w-[100%] ">
          <div className="flex flex-row gap-x-[10.27%] mt-[1.6886%] ml-[3.7%]  font-outfit font-light  text-[#555555]">
            <p>1. Diwali Offer</p> <p>2%</p>
          </div>
          <div className="flex flex-row gap-x-[11.47%] mt-[1.6886%] ml-[3.7%]  font-outfit font-light text-[#555555] ">
            <p>2. VKCOFF</p> <p>3%</p>
          </div>
        </div>
      </div>

      <div className="flex flex-row items-start mx-[1vw] justify-start  gap-x-3 pb-5 ml-[2.083333vw] mt-[3.5185vh] mr-[2.638888vw]">
        <button className="border-2 border-purple-700 rounded-md px-2 py-2 font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
          {" "}
          <span className="px-3 text-[#000]">Print Bill</span>
        </button>
        <button
          className="border-2 border-[#00A101] rounded-md px-2 py-2 font-medium font-outfit flex items-center justify-center flex-row bg-[#00A101] cursor-pointer"
          onClick={handleOpen}>
          {" "}
          <span className="px-2 text-white flex flex-row items-center justify-center">
            Accept Order <CircleCheck color="white" className="mx-2" />
          </span>
        </button>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style} className="rounded-xl">
          <div className="flex justify-between items-center flex-col">
            <div className="w-[100%] flex justify-end">
              <div
                className="w-[30px] h-[30px] rounded-full bg-[#E9E4E4] flex items-center justify-center cursor-pointer"
                onClick={handleClose}>
                <X
                  color="#333333"
                  className="cursor-pointer"
                  onClick={handleClose}
                />
              </div>
            </div>
            <div className="w-[100%] flex items-center justify-center">
              <img
                src={require("../../../assets/modalIcon.png")}
                alt="Successful Modal Icon"
                className="w-[8.42vw]"
              />
            </div>
            <div className="w-[100%] flex items-center justify-center mt-[4.167%]">
              <p className="font-outfit font-medium text-[27px] mx-10 my-2 text-center items-center">
                Order has been successfully accepted for (Goyal Brothers)
              </p>
            </div>

            <div className="w-[100%] flex items-center mt-[2.167%] justify-center gap-x-6">
              <p className="font-outfit font-medium text-[18px] my-2 text-center items-center text-[#475467]">
                Bill Amount: 123456
              </p>
              <p className="font-outfit font-medium text-[18px] my-2 text-center items-center text-[#475467]">
                Dated: 12/12/2023
              </p>
            </div>

            <div className="w-[100%] flex items-center my-[4.167%] justify-center gap-x-6">
              <button className="border-2 border-[#5654B0] rounded-md px-2 py-2 font-medium font-outfit text-[#CAC4D0] flex items-center justify-center flex-row">
                {" "}
                <span className="px-3 text-[#5654B0]">Print Bill</span>
              </button>
              <button
                className="border-2 border-[#5654B0] rounded-md px-2 py-2 font-medium font-outfit flex items-center justify-center flex-row bg-[#5654B0] cursor-pointer"
                onClick={handleOpen}>
                {" "}
                <span className="px-2 text-white flex flex-row items-center justify-center">
                  Go to Order <ArrowRight color="#ffffff" />
                </span>
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default AcceptOrderScreen;
